<template>
  <div>
    <!-- watch more Dialog -->
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeDialog">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <h2 class=" main-color text-center mt-2">
          {{ $t("Sessions Details") }}
        </h2>

        <div>
          <v-container>
            <v-simple-table class="groupDetailsTable">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center third-color">
                      {{ $t("Session Title") }}
                    </th>
                    <th class="text-center third-color">
                      {{ $t("Fees") }}
                    </th>
                    <th class="text-center third-color">
                      {{ $t("Date") }}
                    </th>
                    <th class="text-center third-color">
                      {{ $t("Time") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(session, index) in selectedRepeatedSesions"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ session.lesson_name }}</td>
                    <td>{{ session.lesson_fees }} {{ $t("currency") }}</td>
                    <td>{{ session.date }}</td>
                    <td>{{ session.start }} - {{ session.end }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "groupSessionDetails",
  props: ["dialog", "selectedRepeatedSesions"],
  data() {
    return {};
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scope>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";

.groupDetailsTable th {
  color: $third-color !important;
}

hr {
  background-color: #ccc;
}
</style>
